/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAuthSignup201Response
 */
export interface PostAuthSignup201Response {
    /**
     * 
     * @type {string}
     * @memberof PostAuthSignup201Response
     */
    message: string;
}

/**
 * Check if a given object implements the PostAuthSignup201Response interface.
 */
export function instanceOfPostAuthSignup201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function PostAuthSignup201ResponseFromJSON(json: any): PostAuthSignup201Response {
    return PostAuthSignup201ResponseFromJSONTyped(json, false);
}

export function PostAuthSignup201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAuthSignup201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function PostAuthSignup201ResponseToJSON(value?: PostAuthSignup201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

